define('shared/initializer/form/adapters/mixins/LPOnLoadDataDispatchable',[
    'shared/initializer/form/constants', 
    'shared/lib/RSVP',
    'shared/util/state', 
    'shared/util/queryPersistence',
    'shared/util/dispatchers/FormDataDispatcher',
    'shared/util/tracking/pageName',
    'shared/lib/cookie',
    'shared/my/identity'
], function (
    constants,
    RSVP,
    state,
    queryPersistence,
    FormDataDispatcher,
    pageNameUtil,
    cookie,
    getIdentity
) {
    'use strict';

    function Ctor() {}

    Ctor.prototype.doPageLoad = function() {
        var me = this;
        var dispatcher = new FormDataDispatcher(me.$form);
        return dispatcher.dispatch({
            items:{
                'EFID': {
                    sources: [{type: 'state', key: 'user.ef_id', allowUndefined: true}],
                    targets: [{type: 'form', key: constants.FIELD.EFID}],
                    allowUndefined: true
                },
                'HasOffersTransactionId': {
                    sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.hoTransactionId, allowUndefined: true}],
                    targets: [{type: 'form', key: 'hoTransactionId'}],
                    allowUndefined: true
                },
                'GoogleClickId': {
                    sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.gclid, allowUndefined: true}],
                    targets: [{type: 'form', key: 'gclid'}],
                    allowUndefined: true
                },
                'MarinClickId': {
                    sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.ruboid, allowUndefined: true}],
                    targets: [{type: 'form', key: 'ruboid'}],
                    allowUndefined: true
                },
                'utm_source': {
                    sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.utm_source, allowUndefined: true}],
                    targets: [{type: 'form', key: 'utm_source'}],
                    allowUndefined: true
                },
                'utm_medium': {
                    sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.utm_medium, allowUndefined: true}],
                    targets: [{type: 'form', key: 'utm_medium'}],
                    allowUndefined: true
                },
                'utm_campaign': {
                    sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.utm_campaign, allowUndefined: true}],
                    targets: [{type: 'form', key: 'utm_campaign'}],
                    allowUndefined: true
                },
                'utm_term': {
                    sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.utm_term, allowUndefined: true}],
                    targets: [{type: 'form', key: 'utm_term'}],
                    allowUndefined: true
                },
                'utm_content': {
                    sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.utm_content, allowUndefined: true}],
                    targets: [{type: 'form', key: 'utm_content'}],
                    allowUndefined: true
                },
                'adgroup': {
                    sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.adgroup, allowUndefined: true}],
                    targets: [{type: 'form', key: 'adgroup'}],
                    allowUndefined: true
                },
                'referredby': {
                    sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.referredby, allowUndefined: true}],
                    targets: [{type: 'form', key: constants.FIELD.ReferredBy}],
                    allowUndefined: true
                },
                'referredfrom': {
                    sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.referredfrom, allowUndefined: true}],
                    targets: [{type: 'form', key: constants.FIELD.ReferredFrom}],
                    allowUndefined: true
                },
                'lng': {
                    sources: [{type: 'state', key: 'user.language', allowUndefined: true}],
                    targets: [{type: 'form', key: 'lang'}],
                    allowUndefined: true
                },
                'ptn': {
                    sources: [{type: 'state', key: 'session.partner_code', allowUndefined: true}],
                    targets: [{type: 'form', key: 'partner'}],
                    allowUndefined: true
                },
                'etag': {
                    sources: [
                        {
                            retrieve:function(){
                                return state.get('form.etag').then(function(values){
                                    var formEtag = values && values[0];
                                    if(formEtag){
                                        if(!formEtag.endsWith('_1')){
                                            formEtag += '_1';
                                        }
                                    }

                                    return RSVP.resolve(formEtag);
                                });
                            }
                        },
                        {type: 'state', key: 'page.etag', allowUndefined: true},
                        {type: 'state', key: 'session.etag', allowUndefined: true}
                    ],
                    targets: [{type: 'form', key: 'etag'}],
                    allowUndefined: true
                },
                'memberid':{
                    sources: [{retrieve: function(){
                        return getIdentity();
                    }, allowUndefined: true}],
                    targets: [{type: 'form', key: 'memberid'}],
                    allowUndefined: true
                },
                'local':{
                    sources: [{type: 'state', key: 'user.market', allowUndefined: true}],
                    targets: [{type: 'form', key: 'local'}, {type: 'form', key: 'ctr'}],
                    allowUndefined: true
                },
                'country':{
                    sources: [{type: 'query', key: 'country'}, {type: 'state', key: 'user.market', allowUndefined: true}],
                    targets: [{type: 'form', key: 'country'}],
                    allowUndefined: true
                },
                'state':{
                    sources: [{type: 'query', key: 'state'}, {type: 'state', key: 'form.state', allowUndefined: true}],
                    targets: [{type: 'form', key: 'state'}],
                    allowUndefined: true
                },
                'city':{
                    sources: [{type: 'query', key: 'city'}, {type: 'state', key: 'form.city', allowUndefined: true}],
                    targets: [{type: 'form', key: 'city'}],
                    allowUndefined: true
                },
                'first_name':{
                    sources: [
                        {type: 'query', key: 'first_name'}, 
                        {type: 'query', key: 'firstname'}, 
                        {type: 'state', key: 'form.first_name', allowUndefined: true}, 
                        {type: 'state', key: 'form.firstname', allowUndefined: true}
                    ],
                    targets: [{type: 'form', key: 'first_name'}, {type: 'form', key: 'firstname'}],
                    allowUndefined: true
                },
                'last_name':{
                    sources: [
                        {type: 'query', key: 'last_name'}, 
                        {type: 'query', key: 'lastname'}, 
                        {type: 'state', key: 'form.last_name', allowUndefined: true}, 
                        {type: 'state', key: 'form.lastname', allowUndefined: true}
                    ],
                    targets: [{type: 'form', key: 'last_name'}, {type: 'form', key: 'lastname'}],
                    allowUndefined: true
                },
                'email':{
                    sources: [{type: 'query', key: 'email'}, {type: 'state', key: 'form.email', allowUndefined: true}],
                    targets: [{type: 'form', key: 'email'}],
                    allowUndefined: true
                },
                'telephone':{
                    sources: [{type: 'query', key: 'telephone'}, {type: 'state', key: 'form.telephone', allowUndefined: true}],
                    targets: [{type: 'form', key: 'telephone'}],
                    allowUndefined: true
                },
                'age': {
                    sources: [{type: 'query', key: 'age'}, {type: 'state', key: 'form.age', allowUndefined: true}],
                    targets: [{type: 'form', key: 'age'}],
                    allowUndefined: true
                },
                'callTime': {
                    sources: [{type: 'query', key: 'calltime'}, {type: 'state', key: 'form.calltime', allowUndefined: true}],
                    targets: [{type: 'form', key: 'calltime'}],
                    allowUndefined: true
                },
                'omniture.name':
                {
                    sources: [{
                        retrieve: function(){return pageNameUtil.getConversionPageName.call(me);}
                    }],
                    targets: [{type: 'form', key: constants.FIELD.OMNITURE_NAME}]
                },
                'memberReferUrl': {
                    sources: [{retrieve: function(){return RSVP.resolve(location.href);}}],
                    targets: [{type: 'form', key: 'memberReferUrl'}]
                },
                'pcode': {
                    sources: [{type: 'query', key: 'pcode', doNotWait: true}, {type: 'state', key: 'order.couponCode', doNotWait: true}],
                    targets: [{type: 'state', key: 'order.couponCode'}, {type: 'form', key: 'pcode'}],
                    allowUndefined: true
                },
                'offerid': {
                    sources: [
                        {type: 'query', key: 'offerid', doNotWait: true},
                        {
                            retrieve:function(){
                                return RSVP.resolve(cookie.get('et_offerid'));
                            }
                        },
                        {type: 'state', key: constants.State.OrderOfferId, doNotWait: true}],
                    targets: [{type: 'state', key: constants.State.OrderOfferId}],
                    allowUndefined: true
                }
            },
            timeout: 1000 * 60 * 60
        });
    };

    return Ctor;
});
